import { MetaAdEffectiveStatus } from '@frontend/gql/social/graphql';

export const AD_STATUS_MESSAGES = {
  AD_ON: 'Your ad has been submitted to Meta. Once approved, it will start running.',
  AD_OFF: 'Your ad has been submitted to Meta. Once approved and turned on, it will start running.',
} as const;

/**
 * Determines if an ad status represents an "active" or "on" state
 */
const getActiveStatuses = (): Set<MetaAdEffectiveStatus> =>
  new Set([
    'ACTIVE',
    'PREAPPROVED', // Approved and ready to run
    'IN_PROCESS', // Currently being processed but will be active
  ]);

/**
 * Determines the appropriate success message based on ad status
 */
export const getAdCreationSuccessMessage = (adStatus: MetaAdEffectiveStatus): string => {
  const activeStatuses = getActiveStatuses();

  if (activeStatuses.has(adStatus)) {
    return AD_STATUS_MESSAGES.AD_ON;
  }

  return AD_STATUS_MESSAGES.AD_OFF;
};

/**
 * For debugging and logging purposes
 */
export const getAdStatusCategory = (adStatus: MetaAdEffectiveStatus): 'on' | 'off' => {
  const activeStatuses = getActiveStatuses();
  return activeStatuses.has(adStatus) ? 'on' : 'off';
};
